import Layout from "../include/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { checkAuthenticate } from "../app/providers/authSlice";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import UsersService from "./UsersService";
import Swal from "sweetalert2";
import RolesService from "../roles/RolesService";

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Filarial from "../include/filarial";


export default function UserEdit() {
    const activeLink = "UTILISATEURS "

    const [nom, setNom] = useState('')
    const [prenoms, setPrenoms] = useState('')
    const [username, setUsername] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')
    //const [password, setPassword] = useState('')
    //const [conf_password, setConfPassword] = useState('')

    const [roles, setRoles] = useState([]); //Liste des roles disponible
    const [selectedRoles, setSelectedRoles] = useState([]);

    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()
    const animatedComponents = makeAnimated();
    const location = useLocation()

    const [validationError, setValidationError] = useState({})

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //const for validation form
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        //Fait appel au schema créer prédemment
        //resolver: yupResolver(schema)
    })

    //update fonction
    const handleSubmitUser = async () => {
        //event.preventDefault()
        //Recupérer l'id de l'élément à modifier
        let id = location.state.id
        //Recupérer uniquement les id
        var roleIds = selectedRoles.map((option) => option.value)
        //MApping des données
        /*var roleIds = selectedRoles.map((role) => ({
            idRole: role.value
        }));*/

        let form = {
            id, nom, prenoms, username, telephone, email, roleIds
        }

        //console.log(form)

        await UsersService.update(form, token).then((response) => {
            //console.log(response)

            if (response.status !== 200) {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
            } else {
                //redirection sur index
                navigate(myroutes.users_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2500,
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
        });
    }

    //get liste des roles
    const getRoles = async () => {
        await RolesService.index(token).then((response) => {
            setRoles(response.data.data.roles)
        }).catch(error => {
            console.log(error.message)
        });
    }

    ///Maper les données
    const roleOptions = roles.map((role) => ({
        value: role.id,
        label: role.libelleRole
    }));

    //Recuperer la valeur sélectionnée
    const handleRoleSelection = (selectedOptions) => {
        setSelectedRoles(selectedOptions);
    };

    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }

        //get edit data
        const edit = async () => {
            await UsersService.show(location.state.id, token).then((response) => {
                //console.log(response.data.data.listRoles)
                //Recupérer les roles avec leurs libelle sous forme de tableau
                //const rolesUsers = response.data.data.listRoles.map(item => item.role)
                //console.log(response.data.data)

                const data = response.data.data
                setNom(data.nom)
                setPrenoms(data.prenoms)
                setUsername(data.username)
                setEmail(data.email)
                setTelephone(data.telephone)
                //setStatutId(data.is_active) //get statutId

                //Mapper les données pour le select
                /*setSelectedRoles(rolesUsers.map((options) => ({
                    value: options.id,
                    label: options.libelleRole,
                })))*/

            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message
                })
                setValidationError(error.message)
            });
        }

        //Recuperer la liste des roles de l'utilisateur
        const getRoleUser = async () => {
            await UsersService.getRoleUser(location.state.id, token).then((response) => {
                //console.log(response.data.data)
                //Recupérer les roles avec leurs libelle sous forme de tableau
                const rolesUsers = response.data.data.map(item => item.role)
                //console.log(rolesUsers)

                //const data = response.data.data
                //setStatutId(data.is_active) //get statutId

                //Mapper les données pour le select
                setSelectedRoles(rolesUsers.map((options) => ({
                    value: options.id,
                    label: options.libelleRole,
                })))

            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message
                })
                setValidationError(error.message)
            });
        }

        getRoleUser()
        edit();
        getRoles();

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
            <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Modification </h5>
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>

                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmit(handleSubmitUser)}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-nom">Nom <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("nom")} id="bs-validation-nom" type="text" value={nom} onChange={(e) => setNom(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.nom?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-prenoms">Prénoms <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("prenoms")} id="bs-validation-prenoms" type="text" value={prenoms} onChange={(e) => setPrenoms(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.prenoms?.message}</div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephone">Téléphone <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("telephone")} id="bs-validation-telephone" type="number" value={telephone} onChange={(e) => setTelephone(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.telephone?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-email">Email <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("email")} id="bs-validation-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.email?.message}</div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-roles_options">Rôles <i className="text-danger">*</i></Form.Label>
                                            <Select
                                                options={roleOptions}
                                                isMulti
                                                onChange={handleRoleSelection}
                                                value={selectedRoles}
                                                components={animatedComponents}
                                                required
                                            />
                                            <div className="text-danger">{errors.roles_options?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-username">Username <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" {...register("username")} id="bs-validation-username" type="text" value={username} onChange={(e) => setUsername(e.target.value)}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.username?.message}</div>
                                        </div>

                                        {/**
                                         * <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-name">Mot de passe <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" {...register("password")} id="bs-validation-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                                                placeholder="" required={false} maxLength={100} minLength={8} />
                                            <div className="text-danger">{errors.password?.message}</div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-name">Confirmer Mot de passe <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" {...register("password_confirm")} id="bs-validation-password_confirm" type="password" value={conf_password} onChange={(e) => setConfPassword(e.target.value)}
                                                placeholder="" required={false} maxLength={100} minLength={3} />
                                            <div className="text-danger">{errors.password_confirm?.message}</div>
                                        </div>
                                         */}

                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>


                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}
                </div>

            </div>

        </Layout>
    )
}